/**
 * Project panel
 *
 * Created by stefensuhat on 14/08/18 12.24 PM
 */

import { api, apiv2 } from 'utils';

const baseUrl = 'vouchers';
const defaultState = {
    items: [],
    item: {},
    logs: [],
    users: [],
    saved: false,
    errors: {},
    logMeta: { total: 0, per_page: 0, current_page: 0 },
    meta: { total: 0, per_page: 15, current_page: 1 },
};

export default {
    name: 'voucher',
    state: defaultState,
    reducers: {
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        fetchUserResponse: (state, payload) => ({ ...state, users: payload }),
        fetchLogResponse: (state, payload) => ({ ...state, logs: payload.data, meta: payload.meta }),
        findResponse: (state, payload) => ({ ...state, item: payload }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors, saved: false };
            }

            return { ...state, errors: null, saved: true };
        },

    },
    effects: {
        async fetch(params) {
            await api.get(baseUrl, params)
                .then((response) => this.fetchResponse(response));
        },

        async find(params) {
            await api.get(`${baseUrl}/${params}`)
                .then((response) => this.findResponse(response));
        },
        async save(data) {
            await apiv2.post(baseUrl, data)
                .then((response) => this.saveResponse(response));
        },
        async users(params) {
            await api.get(`${baseUrl}/${params}/users`)
                .then((response) => this.fetchUserResponse(response));
        },
        async fetchLogs(code) {
            await api.get(`${baseUrl}/${code}/logs`)
                .then((response) => this.fetchLogResponse(response));
        },
    },
};
